export default {
  "Yes": "Ya",
  "No": "Tidak",

  "Yes, I'm Sure": "Ya, Saya Yakin",

  "Filter": "Filter",
  "Record": "Catatan",
  "deletedData": "Data berhasil dihapus",
  "dataAdded": "Data berhasil disimpan",

}
